import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import './AdminLogin.css';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState(false);

  useEffect(() => {
    // Si ya está autenticado, redirigir al dashboard
    if (authService.isAuthenticated()) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authService.login(username, password);

      if (result.Success) {
        navigate('/admin/dashboard');
      } else {
        setError(result.Message);
      }
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setForgotPasswordSuccess(false);

    try {
      const result = await authService.forgotPassword(email);

      if (result.success) {
        setForgotPasswordSuccess(true);
      } else {
        setError(result.message);
      }
    } catch (err: any) {
      setError(err.message || 'Error al solicitar restablecimiento');
    } finally {
      setLoading(false);
    }
  };

  if (showForgotPassword) {
    return (
      <div className="admin-login-container">
        <div className="login-box">
          <div className="login-header">
            <h1>🔒 Recuperar Contraseña</h1>
            <p>Ingresa tu email y te enviaremos instrucciones</p>
          </div>

          {forgotPasswordSuccess ? (
            <div className="success-message">
              <p>✅ Si el email existe, recibirás instrucciones para restablecer tu contraseña.</p>
              <button
                className="btn-back"
                onClick={() => {
                  setShowForgotPassword(false);
                  setForgotPasswordSuccess(false);
                  setEmail('');
                }}
              >
                Volver al login
              </button>
            </div>
          ) : (
            <form onSubmit={handleForgotPassword} className="login-form">
              {error && (
                <div className="error-message">
                  ⚠️ {error}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="tu@email.com"
                  disabled={loading}
                />
              </div>

              <button
                type="submit"
                className="btn-login"
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'Enviar Instrucciones'}
              </button>

              <button
                type="button"
                className="btn-forgot-password"
                onClick={() => {
                  setShowForgotPassword(false);
                  setEmail('');
                  setError('');
                }}
                disabled={loading}
              >
                ← Volver al login
              </button>
            </form>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>🔐 Admin Dashboard</h1>
          <p>Sistema de Sistematización</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Usuario</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="Ingresa tu usuario"
              disabled={loading}
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Ingresa tu contraseña"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn-login"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>

          <button
            type="button"
            className="btn-forgot-password"
            onClick={() => {
              setShowForgotPassword(true);
              setError('');
            }}
            disabled={loading}
          >
            ¿Olvidaste tu contraseña?
          </button>
        </form>

        <div className="login-footer">
          <p>Sistema de Sistematización EMTRA</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
